/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ComponentConfigEnforcementOrgUsage } from './componentConfigEnforcementOrgUsage';


export interface ComponentConfigEnforcementTypeSpec { 
    enforcement_type?: object;
    next_action_timestamp?: Date;
    org_usage?: Array<ComponentConfigEnforcementOrgUsage>;
}

